import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot,} from '@angular/router';

import { AppConfigService } from 'app/services/app-config/app-config.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { UserFeatureService } from 'app/services/user-feature/user-feature.service';

@Injectable()
export class AuthorizationGuard implements CanActivate {

  constructor(
    private router: Router,
    private userFeatureService: UserFeatureService,
    private activatedRoute: ActivatedRoute,
    private appConfigService: AppConfigService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let path = state.url.substring(0, state.url.indexOf('?'));
    path = path.length === 0 ? state.url : path;
    switch (path) {
      case '/approval':
        if (!this.userFeatureService.canShowApprovalList()) {
          this.router.navigate([''], { queryParams: { returnUrl: state.url } });
          return false;
        }
        break;
    }
    return true;
  }

}




// WEBPACK FOOTER //
// ./src/app/services/guard/authorization.guard.ts